// Derives normalised identity values from the Auth0 `user` object.
// See docs/superpowers/specs/2026-07-02-jwt-identity-normalisation-design.md

// Email local-part (before '@'). Empty string if email is absent or has no '@'.
function emailLocalPart(user) {
  const email = user && user.email;
  if (typeof email !== 'string') return '';
  const at = email.indexOf('@');
  return at <= 0 ? '' : email.substring(0, at);
}

// Remove all whitespace (leading, trailing, and internal). Preserves case
// and every other character.
function stripWhitespace(value) {
  return String(value == null ? '' : value).replace(/\s+/g, '');
}

// Machine-safe base for id.reporter; the caller appends the index.
// nickname (whitespace-stripped) -> email local-part -> 'missing'.
export function reporterBase(user) {
  const fromNickname = stripWhitespace(user && user.nickname);
  if (fromNickname) return fromNickname;
  const fromEmail = stripWhitespace(emailLocalPart(user));
  if (fromEmail) return fromEmail;
  return 'missing';
}

// Machine-safe customer identifier for feedback assertions. Email local-part
// with any -api/-portal/-cat suffix stripped, then '-cat' appended. Falls back
// to 'missing' when the email claim is absent, yielding 'missing-cat' (a clear
// signal of a likely configuration problem rather than a thrown error).
export function customerId(user) {
  let base = emailLocalPart(user) || 'missing';
  for (const suffix of ['-api', '-portal', '-cat']) {
    if (base.endsWith(suffix)) {
      base = base.substring(0, base.indexOf(suffix));
    }
  }
  return base + '-cat';
}

// Human-facing name for the account menu and support-form prefill.
// First present claim, returned verbatim: name -> nickname -> email local-part -> 'User'.
// "Present" = a string with non-whitespace content.
export function displayName(user) {
  const candidates = [
    user && user.name,
    user && user.nickname,
    emailLocalPart(user),
  ];
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim() !== '') return candidate;
  }
  return 'User';
}
